var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Module', {
    directives: [{
      name: "report",
      rawName: "v-report.module",
      value: {},
      expression: "{}",
      modifiers: {
        "module": true
      }
    }]
  }, [_c('div', {
    staticClass: "top"
  }, [_vm.isVip && (_vm.belongsList.length >= 2 || _vm.currentLevelList.length >= 2) ? [_c('Title', {
    attrs: {
      "level": _vm.currentLevel,
      "title": "我的专属福利",
      "data": _vm.forceData,
      "subPageInfo": _vm.subPageInfo,
      "report": _vm.reportData.专属福利更多
    }
  }), _vm.isVip ? _c('p', {
    staticClass: "desc"
  }, [_vm._v("由您尊贵的VIP身份与" + _vm._s(_vm.getLevelDisplay(_vm.currentLevel)) + "等级定制而成")]) : _vm._e(), _vm.isMounted && _vm.wording ? _c('TipWording', {
    attrs: {
      "wording": _vm.wording
    }
  }) : _vm._e()] : !_vm.isVip && _vm.openVipList.length >= 2 ? [_c('Title', {
    attrs: {
      "title": "我的专属优惠",
      "data": _vm.openVipMod.data,
      "report": _vm.reportData.开通优惠更多
    }
  }), _vm.isMounted && _vm.wording ? _c('TipWording', {
    attrs: {
      "wording": _vm.wording
    }
  }) : _vm._e()] : _vm._e(), _vm.isMounted && _vm.giftMod ? _c('GiftModal', {
    attrs: {
      "data": _vm.giftMod
    }
  }) : _vm._e()], 2), !_vm.isVip && _vm.openVipList.length >= 2 ? _c('OpenMod', {
    attrs: {
      "data": _vm.openVipMod.data
    }
  }) : _vm._e(), _c('div', {
    staticClass: "box",
    class: {
      yellow: !_vm.isVip
    }
  }, [!_vm.isVip && (_vm.belongsList.length >= 2 || _vm.currentLevelList.length >= 2) ? _c('div', {
    staticClass: "title_box"
  }, [_c('div', {
    staticClass: "a"
  }, [_c('span', {
    staticClass: "a_title_line"
  }), _c('div', {
    staticClass: "a_title"
  }, [_vm._v("开启VIP后，可享受以下福利")]), _c('span', {
    staticClass: "a_title_line"
  })]), _c('Title', {
    staticClass: "b",
    attrs: {
      "title": "会员专属福利",
      "data": _vm.data,
      "subPageInfo": _vm.subPageInfo,
      "report": _vm.reportData.专属福利更多
    }
  })], 1) : _vm._e(), _vm.belongsList.length >= 2 ? _c('VerticalList', {
    staticClass: "belong_list",
    attrs: {
      "hide-bottom-margin": false
    }
  }, _vm._l(_vm.belongsList, function (item, index) {
    return _c('WelfareItem', {
      key: index,
      attrs: {
        "index": index,
        "item": item,
        "showVipIcon": true,
        "modId": _vm.belongsMod.data.tModDescInfo.sModId,
        "channelId": _vm.belongsMod.data.tModDescInfo.sChannelID,
        "ip": _vm.ip,
        "platform": _vm.platform
      }
    });
  }), 1) : _vm._e(), _vm.currentLevelList.length >= 2 ? _c('VerticalList', {
    attrs: {
      "hide-bottom-margin": true
    }
  }, _vm._l(_vm.currentLevelList, function (item, index) {
    return _c('WelfareItem', {
      key: index,
      attrs: {
        "index": index,
        "item": item,
        "modId": _vm.levelMod.data.tModDescInfo.sModId,
        "channelId": _vm.levelMod.data.tModDescInfo.sChannelID,
        "ip": _vm.ip,
        "platform": _vm.platform
      }
    });
  }), 1) : _vm._e(), _vm.currentLevel < 8 && _vm.nextLevelList.length >= 2 && _vm.isVip ? _c('div', {
    staticClass: "next_wel"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("\n          升级至\n          "), _c('span', {
    staticClass: "gold"
  }, [_vm._v(_vm._s(_vm.getLevelDisplay(_vm.currentLevel + 1)))]), _vm._v(" 可解锁以下福利\n        ")]), _c('div', {
    directives: [{
      name: "report",
      rawName: "v-report",
      value: _vm.reportData.升级攻略,
      expression: "reportData.升级攻略"
    }],
    staticClass: "right",
    on: {
      "click": function click($event) {
        return _vm.openUrl('//film.qq.com/weixin/user_grade.html');
      }
    }
  }, [_vm._v("查看升级攻略>\n        ")])]), _c('HorizontalScroll', {
    staticClass: "nw_list"
  }, _vm._l(_vm.nextLevelList, function (item, index) {
    return _c('li', {
      directives: [{
        name: "report",
        rawName: "v-report",
        value: _vm.reportData.下一级福利海报(item.sTitle, item.sActID),
        expression: "reportData.下一级福利海报(item.sTitle,item.sActID)"
      }],
      key: index,
      on: {
        "click": function click($event) {
          return _vm.openNextLevelItem(item);
        }
      }
    }, [_c('BaseItem', {
      attrs: {
        "item": item,
        "has-layer": true,
        "level": _vm.currentLevel,
        "trigger-default": false
      }
    }, [_c('img', {
      staticClass: "lock",
      attrs: {
        "slot": "icon",
        "src": require("@/assets/lock.svg"),
        "alt": ""
      },
      slot: "icon"
    })]), item.tActState.iParticipants && item.tActState.iParticipants >= 500 ? _c('p', {
      staticClass: "txt"
    }, [_vm._v("已有" + _vm._s(_vm._f("beautifyNumber")(item.tActState.iParticipants)) + "人享受")]) : _c('p', {
      staticClass: "txt"
    }, [_c('img', {
      staticClass: "icon",
      attrs: {
        "src": require("@/assets/hot.svg"),
        "alt": ""
      }
    }), _c('span', {
      staticClass: "sub"
    }, [_vm._v("火热抢")])])], 1);
  }), 0)], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };